import React from 'react';
import { Link } from 'react-router-dom';
import { mockCategories, mockTopics } from '../data';

const ForumHome: React.FC = () => {
  const getLastTopicForCategory = (categoryId: string) => {
    return mockTopics
      .filter(topic => topic.categoryId === categoryId)
      .sort((a, b) => new Date(b.lastPostAt).getTime() - new Date(a.lastPostAt).getTime())[0];
  };

  return (
    <div className="forum-home">
      <div className="announcement-banner">
        <div className="announcement-content">
          <span className="announcement-icon">⚠️</span>
          <span className="announcement-text">
            <strong>ANNOUNCEMENT:</strong> The 2025 Search Party has been cancelled. 
            <Link to="/topic/3-8" className="announcement-link">Click here for details</Link>
          </span>
        </div>
      </div>
      
      <div className="forum-container">
        <div className="forum-header">
          <h1 className="forum-title">Goosifer Forum</h1>
          <p className="forum-description">
            A forum where curiosity meets mystery as we try to uncover the secrets of Goosifer aka the Sloan's Lake Monster or Colfax Creature
          </p>
        </div>
        
        <ul className="category-list">
          {mockCategories.map(category => {
            const lastTopic = getLastTopicForCategory(category.id);
            return (
              <li key={category.id} className="category-item">
                <Link to={`/category/${category.id}`} className="category-link">
                  <div className="category-content">
                    <div className="category-info">
                      <h3>{category.name}</h3>
                      <p>{category.description}</p>
                      {lastTopic && (
                        <div className="category-last-topic">
                          <small>
                            Last post: <span className="topic-author">{lastTopic.author.username}</span> - {new Date(lastTopic.lastPostAt).toLocaleDateString()}
                          </small>
                        </div>
                      )}
                    </div>
                    <div className="category-stats">
                      <div>Topics: {category.topicCount}</div>
                      <div>Posts: {category.postCount}</div>
                    </div>
                  </div>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="forum-container">
        <div className="forum-header">
          <h2 className="forum-title">Recent Activity</h2>
        </div>
        <div className="recent-topics">
          {mockTopics
            .sort((a, b) => new Date(b.lastPostAt).getTime() - new Date(a.lastPostAt).getTime())
            .slice(0, 5)
            .map(topic => (
              <div key={topic.id} className="topic-item">
                <div className="topic-header">
                  <Link to={`/topic/${topic.id}`} className="topic-title">
                    {topic.title}
                  </Link>
                  <div className="topic-meta">
                    by <span className="topic-author">{topic.author.username}</span>
                  </div>
                </div>
                <div className="topic-stats">
                  <span>Posts: {topic.postCount}</span>
                  <span>Views: {topic.viewCount}</span>
                  <span>Last: {new Date(topic.lastPostAt).toLocaleDateString()}</span>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ForumHome; 